import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ClipboardUtilityService {
    async copyText(text: string): Promise<void> {
        try {
            if (!navigator.clipboard?.writeText) {
                throw new Error('Clipboard API unavailable');
            }

            await navigator.clipboard.writeText(text);
        }
        catch {
            this.copyTextWithTextAreaFallback(text);
        }
    }

    private copyTextWithTextAreaFallback(text: string): void {
        const textArea: HTMLTextAreaElement = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
    }
}
